import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-connection-progress',
  templateUrl: './connection-progress.component.html',
  styleUrls: ['./connection-progress.component.scss']
})
export class ConnectionProgressComponent  {

  @Input() stage: number;
  constructor() { }

}
